import React, { useState, useEffect } from "react";
import * as styles from "./index.scss";
import { AddressesState } from "./models";
import { useIntl } from "react-intl";
import Icon from "../../components/icon";
import { Row, Col, Form, Cascader } from "antd";
import Modal from "../../wrappers/modal";
import Checkbox from "../../wrappers/checkbox";
import Input from "../../wrappers/input";
import Select from "../../wrappers/select";
import { PrimaryButton } from "../../wrappers/button";
import { addressDatas } from "../../helpers/addressData";
import { useTheme } from "styled-components";

const ThemeForm = ({ handleSubmit, addressData }: any) => {
  const { formatMessage } = useIntl();
  const { primaryColor } = useTheme();

  const [form] = Form.useForm();
  const [isDefault, setDefault] = useState(false);
  const [addressTagIndex, setTagIndex] = useState(-1);
  const [addresss, setAddress] = useState({});
  const [defaultAddresss, setdefaultAddresss] = useState([]);

  useEffect(() => {
    if (addressData) {
      setDefault(addressData.is_default);
      form.setFieldsValue({
        province: addressData.province,
        city: addressData.city,
        area: addressData.area,
        recipient_telephone: addressData.recipient_telephone,
        recipient_name: addressData.recipient_name,
        address_alias: addressData.address_alias,
        address_details: addressData.address_details,
        is_default: addressData.is_default === 1 ? true : false,
        address_country: [
          addressData.province,
          addressData.city,
          addressData.area,
        ],
      });

      if (addressData.address_alias === "家") {
        setTagIndex(0);
      } else if (addressData.address_alias === "公司") {
        setTagIndex(1);
      } else if (addressData.address_alias === "学校") {
        setTagIndex(2);
      } else {
        setTagIndex(-1);
      }

      setAddress({
        province: addressData.province,
        city: addressData.city,
        area: addressData.area,
      });
    }
  }, [addressData]);

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const handleSubmitForm = (value: any) => {
    value.is_default = isDefault;
    const formValue = { ...value, ...addresss };
    delete formValue.address_country;
    if (!formValue.address_alias) {
      formValue.address_alias = "";
    }
    handleSubmit(formValue);
  };

  const handleCheckBoxChange = (e: any) => {
    setDefault(e.target.checked);
  };

  const addressTagData = [
    formatMessage({ id: "Home" }),
    formatMessage({ id: "Firm" }),
    formatMessage({ id: "School" }),
  ];

  const handleAddressChange = value => {
    if (value && value.length) {
      const addr = {
        province: value[0],
        city: value[1],
        area: value[2],
      };
      setAddress(addr);
    }
  };

  const requiredText = formatMessage({
    id: "Required",
  });
  return (
    <Form
      name="moonlight"
      form={form}
      initialValues={{ remember: true }}
      onFinish={handleSubmitForm}
      onFinishFailed={onFinishFailed}
      style={{ padding: "20px" }}
    >
      <h4>{formatMessage({ id: "Consignee" })} </h4>
      <Form.Item
        name="recipient_name"
        rules={[{ required: true, message: requiredText }]}
      >
        <Input
          placeholder={`${formatMessage({
            id: "Consignee",
          })} *`}
        />
      </Form.Item>
      <h4>{formatMessage({ id: "CellphoneNumber" })}</h4>
      <Row gutter={10}>
        <Col span={8}>
          <Form.Item>
            <Select defaultValue={1}>
              <Select.Option value={1}>中国大陆 +86</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            name="recipient_telephone"
            rules={[
              {
                pattern: /^1[3|4|5|7|8][0-9]{9}$/,
                message: formatMessage({ id: "PleaseEnterTelePhone" }),
              },
            ]}
          >
            <Input
              placeholder={`${formatMessage({
                id: "CellphoneNumber",
              })}*`}
            />
          </Form.Item>
        </Col>
      </Row>

      <h4>{formatMessage({ id: "Address" })} </h4>
      <Form.Item
        name="address_country"
        rules={[{ required: true, message: requiredText }]}
      >
        <Cascader
          options={addressDatas}
          defaultValue={defaultAddresss}
          placeholder={formatMessage({ id: "PleaseSelectOptions" })}
          onChange={val => {
            handleAddressChange(val);
          }}
          style={{ width: "100%" }}
        ></Cascader>
      </Form.Item>
      <Form.Item
        name="address_details"
        rules={[{ required: true, message: requiredText }]}
      >
        <Input
          placeholder={`${formatMessage({
            id: "DetailedAddressInfo",
          })} *`}
        />
      </Form.Item>

      <h4>{formatMessage({ id: "AddressTag" })}</h4>
      <Row gutter={10}>
        {addressTagData.map((item, index) => (
          <Col span={3}>
            <div
              onClick={() => {
                form.setFieldsValue({ address_alias: item }),
                  setTagIndex(index);
              }}
              style={{
                background:
                  index === addressTagIndex ? primaryColor : "#EAEAEA",
                color: "white",
                padding: "5px 10px",
                borderRadius: "10px",
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              {item}
            </div>
          </Col>
        ))}
        <Col span={15}>
          <Form.Item name="address_alias">
            <Input
              placeholder={`${formatMessage({
                id: "AddressTag",
              })}`}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="is_default">
            <Checkbox
              shape="circle"
              borderWidth="2px"
              checked={isDefault}
              // defaultChecked={isDefault ||isDefaultAddr}
              onChange={e => handleCheckBoxChange(e)}
            >
              {formatMessage({
                id: "SetAsDefault",
              })}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={16}></Col>
        <Col span={8} style={{ textAlign: "right" }}>
          <PrimaryButton htmlType="submit" block bgColor={primaryColor}>
            {formatMessage({ id: "Submit" })}
            <Icon type="icont1_correct" />
          </PrimaryButton>
        </Col>
      </Row>
    </Form>
  );
};

export type AddressFormProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (payload: AddressValuesType) => void;
  addressData?: AddressesState["address"][0];
  classNamePrefix?: "" | "mobile";
};

export type AddressValuesType = {
  // 和后端字段保持一致
  province: string;
  city: string;
  area: string;
  recipient_name: string;
  recipient_telephone: string;
  address_alias: string;
  address_details: string;
  is_default: boolean | number;
};

const AddressForm: React.FC<AddressFormProps> = ({
  classNamePrefix,
  onClose,
  onSubmit,
  isOpen,
  addressData,
}) => {
  const { formatMessage } = useIntl();

  const handleSubmit = (values: AddressValuesType) => {
    const data = { ...values, callback: onClose };

    if (values.is_default) {
      data.is_default = 1;
    } else {
      data.is_default = 0;
    }

    onSubmit(data);
  };

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      width={classNamePrefix === "" ? 560 : "100vw"}
      footer={null}
      title={formatMessage({
        id: addressData ? "EditShippingAddress" : "AddShippingAddress",
      })}
      bgColor="#f7f7f7"
    >
      <ThemeForm handleSubmit={handleSubmit} addressData={addressData} />
    </Modal>
  );
};

export default AddressForm;
